export const mockData = {
  hero: {
    title: "WVOD Power 93",
    tagline: "The Voice of the Diaspora",
    description: "We bring you the best of classic hits, soulful melodies, and timeless tunes that resonate with the diaspora. Tune in to experience the power of music that transcends borders and generations.",
    listeners: "1,247"
  },
  
  genres: [
    "Hip Hop",
    "House",
    "RnB",
    "Reggae",
    "Dancehall",
    "Calypso",
    "Soca",
    "Reggaeton",
    "Afrobeats"
  ],
  
  about: {
    description: "Join DJ MG, C Fresh, Infamous SoLJah sound and the rest of the WVOD POWER 93 team as we take you on a musical journey through the ages. From the golden era to modern hits, we curate the perfect blend of tracks that celebrate the rich tapestry of music while providing top of the hour news, informative shows on the history of the diaspora, entertainment and daily devotions to help you have a good day on purpose."
  },
  
  djs: [
    {
      name: "DJ MG",
      role: "Lead DJ",
      bio: "Bringing the heat with classic hits and contemporary vibes"
    },
    {
      name: "C Fresh",
      role: "Host & DJ",
      bio: "Your guide through the musical journey of the diaspora"
    },
    {
      name: "Infamous SoLJah",
      role: "Sound Master",
      bio: "Spinning the best and the rest across all genres"
    }
  ],
  
  schedule: [
    {
      name: "Morning Drive",
      time: "Monday - Friday | 6:00 AM - 10:00 AM",
      description: "Start your day with classic hits, news updates, and daily devotions"
    },
    {
      name: "Midday Classics",
      time: "Monday - Friday | 12:00 PM - 2:00 PM",
      description: "The perfect lunch companion with timeless tracks"
    },
    {
      name: "Diaspora History Hour",
      time: "Tuesday & Thursday | 7:00 PM - 8:00 PM",
      description: "Informative shows exploring the rich history of the diaspora"
    },
    {
      name: "Weekend Vibes",
      time: "Saturday - Sunday | 2:00 PM - 6:00 PM",
      description: "Non-stop hits across Hip Hop, Reggae, Dancehall, Soca, and more"
    },
    {
      name: "Reggae Sunday",
      time: "Sunday | 9:00 AM - 12:00 PM",
      description: "The best in Reggae and Dancehall to start your Sunday right"
    },
    {
      name: "Late Night Mix",
      time: "Friday - Saturday | 10:00 PM - 2:00 AM",
      description: "Late night energy with Afrobeats, House, and Reggaeton"
    }
  ],
  
  contact: {
    email: "info@wvodpower93.com",
    phone: "+1 (555) POWER-93",
    location: "Broadcasting to the Diaspora Worldwide"
  },
  
  gratitude: [
    {
      message: "Grateful for the music that connects us to our roots",
      author: "Maria L."
    },
    {
      message: "Thank you for bringing back the classics! Makes my day every time",
      author: "James K."
    },
    {
      message: "Love the morning devotions - starting my day with purpose",
      author: "Patricia W."
    },
    {
      message: "The history shows are so educational and inspiring",
      author: "David M."
    }
  ]
};